import { downloadBlob } from "./fileDownload";

const escapeCsvValue = (value) => {
  const str = value === null || value === undefined ? "" : String(value);
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

/**
 * Exports an array of plain objects as a CSV download.
 * `columns` is `[{ key, header }]` so callers control column order/labels
 * without needing to pre-shape the row objects.
 */
export const exportRowsToCsv = (rows, columns, filename) => {
  if (!rows?.length) return;

  const header = columns.map((col) => escapeCsvValue(col.header)).join(",");
  const body = rows
    .map((row) => columns.map((col) => escapeCsvValue(row[col.key])).join(","))
    .join("\n");

  const blob = new Blob([`${header}\n${body}`], { type: "text/csv;charset=utf-8;" });
  downloadBlob(blob, filename);
};
